import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useLegalDocuments() {
  const docs = ref({})

  const fetchSettingsFileDoc = async () => {
    try {
      const response = await store.dispatch('api/fetchSettingDoc')
      docs.value = response.data
    } catch (error) {}
  }

  const getDocUrl = slug => {
    if (Object.prototype.hasOwnProperty.call(docs.value, slug)) {
      return docs.value[slug]
    }
    return null
  }

  return {
    docs,
    fetchSettingsFileDoc,
    getDocUrl,
  }
}
